import React, { Component } from 'react';
import DefaultErrorComponent from './DefaultErrorComponent';
import PropTypes from 'prop-types';
export default class HoneybadgerErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            info: null,
            errorOccurred: false
        };
        this.props.honeybadger.afterNotify((error, _notice) => {
            if (!error && this.props.showUserFeedbackFormOnError) {
                this.props.honeybadger.showUserFeedbackForm();
            }
        });
    }
    static getDerivedStateFromError(error) {
        return { error: error, errorOccurred: true, info: null };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ errorOccurred: true, error: error, info: errorInfo });
        this.props.honeybadger.notify(error, { context: errorInfo });
    }
    getErrorComponent() {
        return this.props.ErrorComponent
            ? React.createElement(this.props.ErrorComponent, this.state)
            : React.createElement(DefaultErrorComponent, { ...this.state });
    }
    render() {
        return (React.createElement(React.Fragment, null, this.state.errorOccurred
            ? this.getErrorComponent()
            : this.props.children));
    }
}
HoneybadgerErrorBoundary.propTypes = {
    honeybadger: PropTypes.object.isRequired,
    showUserFeedbackFormOnError: PropTypes.bool,
    children: PropTypes.element,
    ErrorComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
};
HoneybadgerErrorBoundary.defaultProps = {
    showUserFeedbackFormOnError: false
};
//# sourceMappingURL=HoneybadgerErrorBoundary.js.map